import classes from "./CircleColored.module.scss"
const CircleColored = props => {
  return (
    <span className={classes.CirclePink + " " + (props.customClass ? props.customClass : null ) }></span>
  )
}


export default CircleColored;